<div class="ki-raster">
  <div class="ki-raster__spalte">
    <div class="ki-raster__label" id="ki-raster-kontingent">{{ 'settings.ki.abschnitt.kontingent' | translate }}</div>
    <div class="ki-raster__kontingent">
      <div
        class="ki-raster__segment"
        role="tablist"
        aria-labelledby="ki-raster-kontingent"
        data-testid="ki-settings-kontingent"
      >
        @for (option of [false, true]; track option) {
          <button
            type="button"
            role="tab"
            class="ki-raster__tab"
            [class.ki-raster__tab--aktiv]="option === begrenzt()"
            [attr.aria-selected]="option === begrenzt()"
            (click)="onBegrenzt(option)"
          >
            {{ (option ? 'settings.ki.raster.begrenzt' : 'settings.ki.raster.unbegrenzt') | translate }}
          </button>
        }
      </div>
      @if (begrenzt()) {
        <div class="ki-raster__tokens" [class.ki-raster__tokens--fehler]="kontingentFehler()">
          <input
            class="ki-raster__tokens-feld"
            type="text"
            inputmode="numeric"
            [attr.maxlength]="tokensMaxLaenge"
            [value]="kontingentText()"
            [attr.aria-label]="'settings.ki.raster.tokensLabel' | translate"
            [attr.aria-invalid]="kontingentFehler()"
            [attr.aria-describedby]="kontingentFehler() ? 'ki-raster-kontingent-fehler' : null"
            (input)="onTokens($event)"
          />
          <span class="ki-raster__suffix">{{ 'settings.ki.raster.tokens' | translate }}</span>
        </div>
      }
    </div>
    @if (kontingentFehler()) {
      <div
        class="ki-raster__fehler"
        id="ki-raster-kontingent-fehler"
        role="alert"
        data-testid="ki-settings-kontingent-fehler"
      >
        {{ 'settings.ki.raster.kontingentFehler' | translate }}
      </div>
    }
  </div>

  <label class="ki-raster__spalte">
    <div class="ki-raster__label">{{ 'settings.ki.abschnitt.aufbewahrung' | translate }}</div>
    <select class="ki-raster__select" data-testid="ki-settings-aufbewahrung" (change)="onAufbewahrung($event)">
      @for (tage of aufbewahrungOptionen; track tage) {
        <option [value]="tage" [selected]="tage === aufbewahrung()">
          {{ 'settings.ki.raster.tage' | translate: { tage } }}
        </option>
      }
    </select>
  </label>

  <div class="ki-raster__spalte">
    <div class="ki-raster__label">{{ 'settings.ki.abschnitt.auditInhalte' | translate }}</div>
    <div class="ki-raster__schalter">
      <app-ki-switch
        testId="ki-settings-audit-inhalte"
        [an]="auditInhalte()"
        [label]="'settings.ki.raster.auditInhalteLabel' | translate"
        (geaendert)="onAuditInhalte($event)"
      ></app-ki-switch>
      <span class="ki-raster__hinweis">
        {{ (auditInhalte() ? 'settings.ki.raster.auditInhalteAn' : 'settings.ki.raster.auditInhalteAus') | translate }}
      </span>
    </div>
  </div>
</div>
